import LoginSignupLayout from './LoginSignupLayout';

export default LoginSignupLayout;
